// extracted by mini-css-extract-plugin
export default {"Select":"GearSlot_Select__tR7dE","SettingsContent":"GearSlot_SettingsContent__WYRLY","Ability":"GearSlot_Ability__PAnVC","Gap":"GearSlot_Gap__4aRFl"};